import React, { useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";

import { HeroCentered } from "./components/default-sections/Hero";
import Devider from "./components/default-sections/Devider";

import SnippetCard from "./components/main/SnippetMenu";
import RecentCards from "./components/main/RecentCards";

import { auth } from "./auth/firebase/Firebase";
import { advertisment } from "./assets/const/Images";

import "./assets/css/SnippetCard.css";

function Dashboard() {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
  }, [user, loading, navigate]);

  return (
    <>
      <HeroCentered
        title="asdasdas"
        content="Quickly design and customize responsive mobile-first sites with Bootstrap, 
        the world’s most popular front-end open source toolkit, featuring Sass variables and mixins, responsive grid system, extensive prebuilt components, and powerful JavaScript plugins."
        image={advertisment.browser}
      />
      <Devider />
      <RecentCards/>
      <SnippetCard user={user} />
    </>
  );
}
export default Dashboard;
